import { useHost } from "@xingternal/crate-core-runtime-helper";
const useRoutingData = () => {
  const host = useHost();
  const metadata = host.getXingletMetadata();
  const data = createDataLayer(metadata);
  return data;
};
const createDataLayer = (metadata) => {
  return metadata.map((item) => ({
    xinglet: item.name,
    ...item.contributes
  })).filter((item) => "route" in item || "routes" in item).map((item) => {
    const { routes, route, ...rest } = item;
    if (routes) {
      return routes.map((route2) => ({
        route: route2,
        ...rest
      }));
    } else {
      return [{ route, ...rest }];
    }
  }).flat().map(({
    route,
    xinglet,
    layout,
    activeItem,
    visibleTo,
    trackingChannel,
    pageName
  }) => {
    var _a, _b, _c, _d, _e;
    return {
      route: route || "",
      xinglet,
      layout: layout || "xing",
      activeItem,
      visibleTo: {
        bigScreenUser: (_a = visibleTo == null ? void 0 : visibleTo.bigScreenUser) != null ? _a : false,
        nonArmstrongUser: (_b = visibleTo == null ? void 0 : visibleTo.nonArmstrongUser) != null ? _b : false,
        bigScreenExperiment: visibleTo == null ? void 0 : visibleTo.bigScreenExperiment,
        loggedIn: (_c = visibleTo == null ? void 0 : visibleTo.loggedIn) != null ? _c : true,
        loggedOut: (_d = visibleTo == null ? void 0 : visibleTo.loggedOut) != null ? _d : false,
        softLoggedIn: (_e = visibleTo == null ? void 0 : visibleTo.softLoggedIn) != null ? _e : false,
        bigScreenFeatureSwitch: visibleTo == null ? void 0 : visibleTo.bigScreenFeatureSwitch
      },
      trackingChannel,
      pageName
    };
  });
};
export {
  createDataLayer,
  useRoutingData
};
